<h1 mat-dialog-title style="font-family: 'Open Sans', sans-serif;" i18n>Configurar combustible</h1>
<div mat-dialog-content class="container">
    <p i18n>Las aproximaciones del gasto de combustible se basan en la siguiente información:</p>
    <mat-form-field>
        <mat-select [(value)]="tipusVehicle" i18n-placeholder placeholder="Tipo de vehículo">
            <mat-option value="compacte" i18n>Compacto</mat-option>
            <mat-option value="estandar" i18n>Estándar</mat-option>
            <mat-option value="consumElevat" i18n>Consumo elevado</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <input [(ngModel)]="consumVehicle" matInput i18n-placeholder placeholder="Consumo vehículo" type="number">
        <span matSuffix>l/100kms</span>
    </mat-form-field>
    <mat-form-field>
        <mat-select [(value)]="combustible" i18n-placeholder placeholder="Tipo de combustible">
            <mat-option value="gasolina" i18n>Gasolina</mat-option>
            <mat-option value="diesel" i18n>Diésel</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <input [(ngModel)]="preuCombustible" matInput i18n-placeholder placeholder="Precio de combustible" type="number">
        <span matSuffix>€/L</span>
    </mat-form-field>

</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" color="accent" i18n>Cerrar</button>
    <button mat-button (click)="save()" i18n>Guardar</button>
</div>
